<template>
  <div>
    <import-attendances-attendance-import @imported="loadData" />

    <export-attendances-attendance-export ref="export" />
  </div>      
</template>
<script>
  export default {
    components: {
      ImportAttendancesAttendanceImport: () => import('@/components/import/attendances/AttendanceImport'),
      ExportAttendancesAttendanceExport: () => import('@/components/export/attendances/AttendanceExport'),
    },
    metaInfo () {
      return {
        title: 'Attendance Import & Sync',        
      }
    },
    methods: {
      loadData () {
        this.$refs.export.loadData()
      },
    },
  }
</script>
